import useUserDoc from '../../../hooks/useUserDoc'
import useActiveUid from '../../../hooks/useActiveUid'

export const useProfileData = (uid?: string) => {
  const myUid = useActiveUid()
  const effectiveUid = uid || myUid
  const user = useUserDoc(effectiveUid || '')

  return {
    uid: effectiveUid,
    user,
  }
}
